import firebase from "firebase/app";
import { E2E_AUTH_TOKEN, isE2EAuthEnabled } from "../config/e2e";

export const updateUserToken = async () => {
  if (isE2EAuthEnabled()) {
    sessionStorage.setItem("token", E2E_AUTH_TOKEN);
    return E2E_AUTH_TOKEN;
  }
  const user = firebase.auth().currentUser;
  if (user) {
    return user.getIdToken(true).then((token) => {
      sessionStorage.setItem("token", token);
      return token;
    });
  }
};

export const getUserToken = async (forceUpdate = false) => {
  if (isE2EAuthEnabled()) {
    sessionStorage.setItem("token", E2E_AUTH_TOKEN);
    return E2E_AUTH_TOKEN;
  }
  let currentToken = sessionStorage.getItem("token") as AuthToken;
  if (!currentToken || currentToken.length === 0 || forceUpdate) {
    currentToken = await updateUserToken();
  }
  return currentToken;
};

export const deleteUserToken = () => {
  try {
    sessionStorage.removeItem("token");
  } catch (error) {
    // Not really much we can do about this
  }
};

export const getCurrentUser = () => {
  if (isE2EAuthEnabled()) {
    return {
      uid: E2E_AUTH_TOKEN,
      displayName: "Playwright Super Admin",
      email: "playwright@example.invalid",
      photoURL: null,
    } as unknown as firebase.User;
  }
  return firebase.auth().currentUser;
};
